import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core'
import html2canvas from 'html2canvas';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-qr-popup',
  templateUrl: './qr-popup.component.html',
  styleUrls: ['./qr-popup.component.scss'],
})
export class QrPopupComponent implements OnInit {
  @Input() title: any;
  @Input() id: any;
  @ViewChild('qrcodeElem') qrcodeElem!: ElementRef;
  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public route: ActivatedRoute,
    public router: Router
  ) {}
  elementType: any = 'canvas';

 
  // qrcode!: QRCodeComponent;
  ngOnInit(): void {
    this.inputData = environment.shopUrl + this.id;
  }

  inputData: any = '';

  onDownload() {
    const qrCodeElement = document.getElementById('qrcode');
    if (qrCodeElement) {
      html2canvas(qrCodeElement).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = dataURL;
        link.download = 'qrcode.png';
        link.click();
      });
    } else {
      console.error('QR code element not found.');
    }
  }
  // onDownload(qrcode: any): void {
  //   qrcode.download().subscribe((res: any) => {
  //     // TO DO something!
  //   });
  // }
}
